<template>
  <q-page class="flex flex-center">
    <q-card>
      <q-card-section class="q-pa-md">
        <div class="text-h6 text-center">Profile</div>
        <q-form @submit.prevent="updateProfile">
          <q-input filled v-model="profileForm.email" label="Email" class="q-mt-md" />
          <q-input filled v-model="profileForm.password" label="New Password" type="password" class="q-mt-md" />
          <q-input filled v-model="profileForm.verifyPassword" label="Verify New Password" type="password" class="q-mt-md" />
          <q-btn :disabled="!isFormValid" label="Update Profile" type="submit" color="primary" class="full-width q-mt-md" />
        </q-form>
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script>
export default {
  name: 'ProfilePage',
  data() {
    return {
      profileForm: {
        email: '',
        password: '',
        verifyPassword: ''
      }
    };
  },
  computed: {
    isFormValid() {
      return this.profileForm.password && this.profileForm.password === this.profileForm.verifyPassword;
    }
  },
  methods: {
    updateProfile() {
      if (this.isFormValid) {
        console.log('Profile updated:', this.profileForm);
        // Implement the logic to update the user's profile here
        // Typically, send a request to the backend API
        this.$q.notify({ color: 'green', position: 'top', message: 'Profile successfully updated!', icon: 'check' });
      } else {
        this.$q.notify({ color: 'red', position: 'top', message: 'Passwords do not match.', icon: 'error' });
      }
    }
  }
}
</script>
